import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  postMicrosoftSync,
  postMicrosoftLink,
  postMicrosoftZendesk,
} from '../../apis/auth'
import { setErrors } from '../common/errorsSlice'
import {
  MicrosoftSyncResponse,
  MicrosoftCallbackUrl,
} from '../../types/auth'

export interface MicrosoftSyncState extends MicrosoftSyncResponse {
  isSucceeded: boolean
}

const initialState: MicrosoftSyncState = {
  login_url: "",
  isSucceeded: false,
}

const microsoftSyncSlice = createSlice({
  name: 'microsoftSync',
  initialState,
  reducers: {
    postMicrosoftSyncSuccess: (state, action: PayloadAction<MicrosoftSyncResponse>) => {
      state.login_url = action.payload.login_url
      return state
    },
    postMicrosoftLinkSuccess: (state) => {
      state.isSucceeded = true
      return state
    },
    requestFailure: (state) => {
      state.isSucceeded = false
      return state
    },
  },
})

export const {
  postMicrosoftSyncSuccess,
  postMicrosoftLinkSuccess,
  requestFailure,
} = microsoftSyncSlice.actions

export const microsoftSyncReducer = microsoftSyncSlice.reducer

export const createMicrosoftSync = (
  callback: (microsoft: MicrosoftSyncState) => void,
): AppThunk => async (dispatch) => {
  postMicrosoftSync()
    .then((result) => {
      dispatch(postMicrosoftSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createMicrosoftZendesk = (
  callback: (microsoft: MicrosoftSyncState) => void,
): AppThunk => async (dispatch) => {
  postMicrosoftZendesk()
    .then((result) => {
      dispatch(postMicrosoftSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createMicrosoftLink = (
  params: MicrosoftCallbackUrl,
  callback: (result: boolean) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  postMicrosoftLink(params)
    .then(() => {
      dispatch(postMicrosoftLinkSuccess())
      callback(true)
    })
    .catch((error) => {
      dispatch(requestFailure())
      if (error.needResetToken) {
        dispatch(setErrors({
          status: error.status,
          needResetToken: false,
          errors: [],
        }))
      } else {
        dispatch(setErrors(error))
      }
      errorCallback()
    })
}
